// extracted by mini-css-extract-plugin
export default {"wrapper":"RequestsPage_wrapper__3Dlxo"};